import mainOidc from '@/auth';

let routes = [
  {
    path: 'user',
    component: () => import('@/components/common/RooshRouterView'),
    children: [
      {
        path: 'edit_password',
        name: 'user.edit_password',
        component: () => import('@/views/User/EditPassword'),
      },
      {
        path: 'create_account',
        name: 'user.create_account',
        component: () => import('@/views/User/CreateAccount'),
      },
      {
        path: 'edit_email',
        name: 'user.edit_email',
        component: () => import('@/views/User/EditEmail'),
      },
      {
        path: 'reset_email',
        name: 'user.reset_email',
        component: () => import('@/views/User/ResetEmail'),
      },
    ],
    meta: {
      authName: mainOidc.authName
    },
  },
];

export default routes;

